import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import FadeIn from 'legacy/common/components/transition/FadeIn';

const UploadedMomentsListItem = ({
  filename,
  isUploading
}: {
  filename: string;
  isUploading: boolean;
}) => (
  <FadeIn>
    <div className="flex mt-2 items-center">
      <div className="flex-1 text-[14px] font-bold">{filename}</div>

      {isUploading && (
        <div className="flex-1">
          <Spinner type={SpinnerType.PRIMARY} />
        </div>
      )}
    </div>
  </FadeIn>
);

export default UploadedMomentsListItem;
